<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">Sorting Components Report</h1>
    <div class="flex items-center mb-6">
      <search-with-date-range v-model="form.search" class="mr-0 w-full max-w-md mr-3"/>
      <date-range v-model="form.dateValue" class="mr-0 w-full max-w-md" @reset="reset"/> 
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th
            v-for="(header, index) in headers"
            :key="index"
            class="pb-2 pt-2 px-3">
            {{ replaceUnderscoreWithSpace(header) }}
          </th>
        </tr>
        <tr v-if="inventories.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No reports found.</td>
        </tr>
        <tr 
          v-for="(inventory, tindex) in inventories"
          :key="tindex"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td 
            v-for="(header, cindex) in headers"
            :key="cindex"
            class="border-t">
            <span class="flex items-center px-3 py-2 focus:text-indigo-500">
              {{ inventory[header] }}
            </span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import SearchWithDateRange from '@/Shared/SearchWithDateRange'
import DateRange from '@/Shared/DateRange'
import mapValues from 'lodash/mapValues'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchWithDateRange,
    DateRange
  },
  layout: Layout,
  props: {
    filters: Object,
    inventories: Array,
    headers: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        dateValue: this.filters.dateValue
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/sorting/components/receipts/reports', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    replaceUnderscoreWithSpace(value) {
      return value.split('_').join(' ');
    }
  },
}
</script>
